module.exports = __webpack_public_path__ + "img/icon-level-gold.b6764f3d.png";